module.exports = __webpack_public_path__ + "static/media/cardIconModeration.160cd214.svg";